var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudentProfileBlackFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 1.5H4.5C3.255 1.5 2.25 2.4975 2.25 3.7275V11.91C2.25 13.14 3.255 14.1375 4.5 14.1375H5.07C5.67 14.1375 6.24 14.37 6.66 14.79L7.9425 16.0575C8.5275 16.635 9.48 16.635 10.065 16.0575L11.3475 14.79C11.7675 14.37 12.345 14.1375 12.9375 14.1375H13.5C14.745 14.1375 15.75 13.14 15.75 11.91V3.7275C15.75 2.4975 14.745 1.5 13.5 1.5ZM9 4.3125C9.9675 4.3125 10.7475 5.0925 10.7475 6.06C10.7475 7.0275 9.9675 7.8075 9 7.8075C8.0325 7.8075 7.2525 7.02 7.2525 6.06C7.2525 5.0925 8.0325 4.3125 9 4.3125ZM11.01 11.295H6.99C6.3825 11.295 6.03 10.62 6.3675 10.1175C6.8775 9.36 7.8675 8.85 9 8.85C10.1325 8.85 11.1225 9.36 11.6325 10.1175C11.97 10.62 11.61 11.295 11.01 11.295Z",
    fill: "#0E0C0B",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentProfileBlackFilled);
export default __webpack_public_path__ + "static/media/student_profile_black_filled.61535071d2466ee668d1a4163073406c.svg";
export { ForwardRef as ReactComponent };